// extracted by mini-css-extract-plugin
export default {"preprod-stripes":"preprod-stripes_preprod-stripes__L495Y","alpha":"preprod-stripes_alpha__CSR+2","beta":"preprod-stripes_beta__yoRG4"};